import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const AnnouncementSmallImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '1_1_568', width: 568, height: 568, ratio: 1 },
  { screen: Screen.XS, key: '1_1_768', width: 768, height: 768, ratio: 1 },
  {
    screen: Screen.SM,
    key: '91_12_1024',
    width: 1024, // Screen.MD
    height: 135,
    ratio: 7.58,
  },
  {
    screen: Screen.MD,
    key: '91_12_1366',
    width: 1366,
    height: 180,
    ratio: 7.58,
  },
  {
    screen: Screen.LG,
    key: '1800_103_1600',
    width: 1600,
    height: 92,
    ratio: 17.47,
  },
  {
    screen: Screen.XL,
    key: '1800_103_1920',
    width: 1920,
    height: 110,
    ratio: 17.47,
  },
  {
    screen: Screen.XXL,
    key: '1800_103_2560',
    width: 2540,
    height: 145,
    ratio: 17.47,
  },
];
